import React from 'react';
import './PageHeader.less';

function PageHeader({
  title, subtitle, action, eyebrow, as = 'h1', size = 'md', className = '',
}) {
  const HeadingTag = as;
  return (
    <header
      className={
        `gc-page-header gc-page-header-${size}` +
        (className ? ` ${className}` : '')
      }
    >
      <div className="gc-page-header-text">
        {eyebrow && <p className="gc-page-header-eyebrow">{eyebrow}</p>}
        <HeadingTag className="gc-page-header-title">{title}</HeadingTag>
        {subtitle && <p className="gc-page-header-subtitle">{subtitle}</p>}
      </div>
      {action && <div className="gc-page-header-action">{action}</div>}
    </header>
  );
}

export default PageHeader;
